import React from 'react';
import { Modal } from '@interstate/components/Modal';
import { ExclamationTriangleIcon } from '@interstate/components/Icons/ExclamationTriangleIcon';
import { Typography } from '@interstate/components/Typography';

export interface UnsavedChangesModalProps {
    show: boolean;
    errorMessage: string;
    onHide: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ show, errorMessage, onHide }) => {
    return (
        <Modal
            data-testid="unsaved-changes-modal"
            footer={{
                primary: {
                    action: onHide,
                    label: 'OK'
                }
            }}
            header={
                <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <ExclamationTriangleIcon fontSize="large" />
                    <Typography variant={'h3'}>Validation Errors</Typography>
                </span>
            }
            id="unsaved-changes-modal"
            onHide={onHide}
            size="small"
            show={show}
        >
            <Typography variant={'body-md'} sx={{ marginBottom: '1rem' }}>
                There are validation errors in the Programs & Incentives section:
            </Typography>
            <Typography variant={'strong-sm'}>{errorMessage}</Typography>
        </Modal>
    );
};

export default UnsavedChangesModal;
